import { createSelector } from 'reselect'
import { API_URL_AI_RECOMMENDATIONS } from '../../../constants/apiUrls'
import pendingRequestsSelector from './pendingRequestsSelector'
import requestIsPending from './helpers/requestIsPending'

const aiRecommendationsRequestIsPendingSelector = createSelector(
    pendingRequestsSelector,
    (pendingRequests): boolean => requestIsPending(pendingRequests, API_URL_AI_RECOMMENDATIONS),
)

export default aiRecommendationsRequestIsPendingSelector
